<nb-card>

        <nb-card-header>
          
            <div style="display:flex; width:100%">
                <span>Завантажити відео</span>   
               
                </div>
        </nb-card-header>

        <nb-card-body>
	 	<div class="settingsModalBody">

			<div class="middle">  
      				
				
			
			
				 
			


                     <div>
					 
				
				
				 <div class="progressWrapper"  style="width:100%; position:relative;">

					<div style="display:flex; margin-bottom:5px;">
							<div class="left">0%</div> <div style="display:flex;flex:1; text-align:center">
		<div *ngIf="uploadingProccess" style="display:flex; margin:auto;">{{ uploadingProccess < 100 ? 'Йде завантаження' : 'Завантажено'}}: {{uploadingProccess}}%</div>
		</div> <div class="right">100%</div>
					</div>
					
					<div class="progressBar"> 
					  <nb-progress-bar [value]="uploadingProccess" status="success"></nb-progress-bar>
					</div>
 			 
 				<div *ngIf="uploadError">
					<div class="text-danger text" style="text-align:center; margin-top:10px;">Сталася помилка завантаження.</div>
				</div>
				<div *ngIf="loadingCanceled">
					<div class="text-danger text" style="text-align:center; margin-top:10px;">Завантаження скасовано.</div>
				</div>
				
				<div *ngIf="currentMode === mode.initial && !loadingCanceled  && !uploadError">
					<div class="text">Очікування файлу.</div>
				</div>

				<div *ngIf="currentMode === mode.filePut && !loadingCanceled  && !uploadError">
					<div  class="text">Натисніть на кнопку "Завантажити"</div>
				</div>
				<div  *ngIf="currentMode === mode.loading" class="text"> 
					Будь ласка, не перезавантажуйте цю вкладку до завершення завантаження
				</div>

					<div *ngIf="currentMode === mode.done">

					<div class="text">Файл успішно завантажений. Це вікно можна закрити.</div>
				</div>
				
		 	</div>
 

</div> 
 </div>
			<div   class="bottom">
 
				<div class="left">

					<div  *ngIf="currentMode === mode.initial || currentMode === mode.filePut">
						<input type="file" (change)="fileChange($event.target)" class="file-button"  value="Вибрати файл"   />
					</div>
					
				</div>
 

				<div class="right">

					<div  *ngIf="currentMode === mode.filePut">
						<button nbButton status="primary" (click)="startUpload()">Завантажити</button>
					</div>

					<div *ngIf="currentMode === mode.initial || currentMode === mode.filePut">
						<button nbButton (click)="closeModal()">Скасувати</button>
					</div>

					<div *ngIf="currentMode === mode.done">
						<button nbButton (click)="closeModal()">Закрити вікно</button>
					</div>
				<div *ngIf="currentMode === mode.loading">
						<button nbButton status="danger" (click)="cancelLoading()">Скасувати завантаження</button>
					</div>

 
				</div>
				
			</div>


		</div>
		
	</nb-card-body>
     
</nb-card>
  


 
